<!--
 * @Author: Haoxiwei 1078734933@qq.com
 * @Date: 2023-12-12 13:45:19
 * @LastEditors: Haoxiwei 1078734933@qq.com
 * @LastEditTime: 2024-12-20 10:39:34
 * @FilePath: /wemeet-admin-new/src/views/enterPriseConfig/enterpriseOrder.vue
 * @Description:
 * Copyright (c) 2024 by WeMeet, All Rights Reserved.
-->
<template>
  <div>
    <vab-query-form style="padding-top: 20px">
      <vab-query-form-left-panel :span="24">
        <el-form :inline="true" :model="queryForm" @submit.prevent>
          <el-form-item label="订单编号">
            <el-input v-model="queryForm.orderNo" clearable placeholder="请输入订单编号" @change="queryData"
              @clear="queryData" />
          </el-form-item>
          <el-form-item label="订单状态">
            <el-select v-model="queryForm.status" class="m-2" clearable placeholder="请选择订单类型" @change="queryData">
              <el-option v-for="item in payStatusOption" :key="item.value" :label="item.label" :value="item.value" />
            </el-select>
          </el-form-item>
          <el-form-item label="订单内容">
            <el-select v-model="queryForm.orderService" class="m-2" clearable placeholder="请选择订单内容" @change="queryData">
              <el-option v-for="item in typeOptions" :key="item.goodsCode" :label="item.goodsName"
                :value="item.goodsName" />
            </el-select>
          </el-form-item>
          <el-form-item label="下单机构">
            <el-input v-model="queryForm.enterpriseName" clearable placeholder="请输入下单机构" @change="queryData"
              @clear="queryData" />
          </el-form-item>

          <!-- <el-form-item label="审核状态">
            <el-select v-model="queryForm.status" class="m-2" placeholder="请选择状态" clearable @change="queryData">
              <el-option v-for="item in statusOption" :key="item.value" :label="item.label" :value="item.value" />
            </el-select>
          </el-form-item> -->

          <el-form-item label="下单方式">
            <el-select v-model="queryForm.orderMethod" class="m-2" clearable placeholder="请选择下单方式" @change="queryData">
              <el-option v-for="item in payTypeOption" :key="item.value" :label="item.label" :value="item.value" />
            </el-select>
          </el-form-item>
          <el-form-item label="提交时间">
            <el-date-picker v-model="createTime" end-placeholder="结束时间" :shortcuts="shortcuts" start-placeholder="开始时间"
              type="daterange" value-format="YYYY-MM-DD" />
          </el-form-item>
          <el-form-item>
            <el-button :icon="Search" type="primary" @click="queryData">查询</el-button>
            <el-button :icon="Delete" type="warning" @click="resetQueryData">置空</el-button>
          </el-form-item>
        </el-form>
      </vab-query-form-left-panel>
    </vab-query-form>
    <el-table v-loading="listLoading" border :data="list" :table-layout="'auto'">
      <el-table-column label="订单编号" prop="orderNo" />
      <el-table-column label="订单类型">
        <template #default="{ row }">
          {{ row.orderType == 'MASTER_PRODUCTS' ? '主产品' : '增值产品' }}
        </template>
      </el-table-column>
      <el-table-column label="订单内容" prop="goodsName" />
      <el-table-column label="下单机构" prop="enterpriseName" />
      <el-table-column label="下单方式" prop="payType">
        <template #default="{ row }">
          {{ handlePayType(row) }}
        </template>
      </el-table-column>
      <el-table-column label="有效期" prop="expireTime" />
      <el-table-column label="订单价格" prop="price" />
      <el-table-column label="提交时间" prop="createTime" />
      <el-table-column v-if="customInfo.tenantKey == 'WeMeet'" label="入驻平台来源" prop="eventKey" />
      <!--
      <el-table-column label="交易明细">
        <template #default="{ row }">
          <span v-if="row.payType == 'WECHAT_PAY' && row.status == 'PAY_OVER'">
            {{ row.outOrderNo }}
          </span>
          <el-button plain v-if="
              (row.payType == 'NON_PROFIT_ORG' ||
                row.payType == 'CORPORATE_TRANSFER') &&
              row.status == 'PAY_OVER'
            " @click="handleEdit(row, 'SEE')" type="primary">
            {{
              row.payType == 'NON_PROFIT_ORG' ? '查看证明材料' : '查看支付凭证'
            }}
          </el-button>
          <span v-if="row.status != 'PAY_OVER'">/</span>
        </template>
      </el-table-column>
      <el-table-column label="下单人手机号" prop="phone" />
      <el-table-column label="支付状态" prop="createTime">
        <template #default="{ row }">
          {{ handlePayStatus(row) }}
        </template>
      </el-table-column> -->
      <el-table-column label="订单状态" prop="createTime">
        <template #default="{ row }">
          {{ handlePayStatus(row) }}
        </template>
      </el-table-column>
      <!-- <el-table-column label="提交时间" prop="orderTime">
        <template #default="{ row }">
          {{ handleDate(row.orderTime) }}
        </template>
      </el-table-column> -->

      <!-- <el-table-column label="订单状态" prop="reason" show-overflow-tooltip>
        <template #default="{ row }">
          <span v-if="row.status == 'REJECTED'">{{ row.reason }}</span>
        </template>
      </el-table-column> -->

      <el-table-column label="操作" width="250px">
        <template #default="{ row }">
          <el-button plain type="primary" @click="handleEdit(row, 'SEE')">查看</el-button>
          <el-button v-if="row.status == 'PAY_CONFIRMED' && customInfo.tenantKey == row.eventKey" plain type="success"
            @click="handleEdit(row, 'PAY')">
            确认支付
          </el-button>
        </template>
      </el-table-column>
      <template #empty>
        <!-- <el-image
                class="vab-data-empty"
                :src="require('@/assets/empty_images/data_empty.png')"
              /> -->
        <el-empty class="vab-data-empty" description="暂无数据" />
      </template>
    </el-table>
    <el-pagination background :current-page="queryForm.pageNumber" :layout="layout" :page-size="queryForm.pageSize"
      :total="total" @current-change="handleCurrentChange" @size-change="handleSizeChange" />
    <edit ref="editRef" @fetch-data="fetchData" />
  </div>
</template>

<script>
import {
  defineComponent,
  defineAsyncComponent,
  getCurrentInstance,
  onMounted,
  reactive,
  toRefs,
  onActivated,
  computed,
  watch,
} from 'vue'

import { useStore } from 'vuex'
import { Delete, Plus, Search } from '@element-plus/icons'
import { queryMemberLicense, getAllEnterPriseList, delEnterPrise, queryOrderEnterprise } from '@/api/enterPriseApi'
import { parseTime } from '@/utils/index'
export default defineComponent({
  name: 'EnterpriseOrder',
  components: {
    Edit: defineAsyncComponent(() => import('./components/editOrder')),
  },
  setup() {
    const { proxy } = getCurrentInstance()
    const store = useStore()

    const state = reactive({
      queryForm: {
        endTime: '',
        enterpriseName: '',
        orderNo: '',
        orderService: '',
        payType: '',
        startTime: '',
        status: '',
        pageNum: 1,
        pageSize: 20,
        orderMethod: '',
        goodsName: '',
        eventKey: '',
      },
      shortcuts: [
        {
          text: '上周',
          value: () => {
            const end = new Date()
            const start = new Date()
            start.setDate(start.getDate() - 7)
            return [start, end]
          },
        },
        {
          text: '上月',
          value: () => {
            const end = new Date()
            const start = new Date()
            start.setMonth(start.getMonth() - 1)
            return [start, end]
          },
        },
        {
          text: '最近三个月',
          value: () => {
            const end = new Date()
            const start = new Date()
            start.setMonth(start.getMonth() - 3)
            return [start, end]
          },
        },
      ],
      total: 0,
      shopList: [],
      listLoading: false,
      list: [],
      layout: 'prev, pager, next',
      editRef: null,
      payTypeOption: [
        {
          label: '全部',
          value: '',
        },
        // {
        //   label: '微信支付',
        //   value: 'WECHAT_PAY',
        // },
        // {
        //   label: '非盈利机构',
        //   value: 'NON_PROFIT_ORG',
        // },
        // {
        //   label: '对公转账',
        //   value: 'CORPORATE_TRANSFER',
        // },
        {
          label: '初次开通',
          value: 'FIRST_ORDER',
        },
        {
          label: '续费服务',
          value: 'RENEWAL',
        },

        {
          label: '免费赠送',
          value: 'DONATION',
        },
      ],
      typeOptions: [
        {
          label: '全部',
          value: '',
        },
        {
          label: '机构基础会员',
          value: '机构基础会员',
        },
        // {
        //   label: '中级机构会员',
        //   value: 'INTERMEDIATE_VIP',
        // },
        {
          label: '机构VIP会员',
          value: '机构VIP会员',
        },
        {
          label: 'AI应用',
          value: 'AI应用',
        },
      ],
      payStatusOption: [
        {
          label: '全部',
          value: '',
          type: 'success',
        },
        {
          label: '待支付',
          value: 'PAY_WAIT',
          type: 'success',
        },
        // {
        //   label: '部分支付',
        //   value: 'PAY_PART',
        //   type: 'success',
        // },

        {
          label: '支付成功',
          value: 'PAY_OVER',
          type: 'success',
        },
        {
          label: '支付待确认',
          value: 'PAY_CONFIRMED',
          type: 'success',
        },
        {
          label: '支付不通过',
          value: 'PAY_NOT_PASS',
          type: 'success',
        },
        {
          label: '支付取消',
          value: 'CLOSED',
          type: 'success',
        },
      ],
      statusOption: [
        {
          label: '全部',
          value: '',
          type: 'success',
        },
        {
          label: '试用',
          value: 'TRIAL',
          type: 'success',
        },
        {
          label: '审核通过',
          value: 'AUDIT_APPROVED',
          type: 'success',
        },
        {
          label: '待审核',
          value: 'PENDING_AUDIT',
        },
        {
          label: '审核驳回',
          value: 'REJECTED',
          type: 'danger',
        },
        {
          label: '已启用',
          value: 'ACTIVE',
          type: 'success',
        },
        {
          label: '已禁用',
          value: 'INACTIVATED_BY_SITE',
          type: 'danger',
        },
      ],
      createTime: [],
    })

    const handleEdit = (row, type) => {
      row.formStatus = type
      state.editRef.showEdit(row)
    }

    const handleDelete = (row) => {
      if (row.enterpriseCode) {
        proxy.$baseConfirm('你确定要删除当前项吗', null, async () => {
          const { msg } = await delEnterPrise({
            enterpriseCode: row.enterpriseCode,
          })
          proxy.$baseMessage(`操作成功`, 'success', 'vab-hey-message-success')
          await fetchData()
        })
      }
    }

    const queryData = () => {
      if (state.createTime && state.createTime.length > 0) {
        console.log(state.createTime)
        state.queryForm.startTime = parseTime(state.createTime[0], '{y}-{m}-{d}')
        state.queryForm.endTime = parseTime(state.createTime[1], '{y}-{m}-{d}')
      } else {
        state.queryForm.startTime = ''
        state.queryForm.endTime = ''
      }
      fetchData()
    }

    const resetQueryData = () => {
      state.queryForm = {
        endTime: '',
        enterpriseName: '',
        orderNo: '',
        orderService: '',
        payType: '',
        startTime: '',
        status: '',
        pageNum: 1,
        pageSize: 20,
        orderMethod: '',
      }
      state.createTime = []
      fetchData()
    }

    const fetchData = async () => {
      state.listLoading = true

      const { data: typeList } = await queryMemberLicense()
      const { data } = await queryOrderEnterprise(state.queryForm)
      console.log(data, '1123123')
      state.list = data.list
      state.total = data.total
      console.log(typeList)
      state.typeOptions = typeList
      state.listLoading = false
    }

    const handleSizeChange = (val) => {
      state.queryForm.pageSize = val
      queryData()
    }
    const handleCurrentChange = (val) => {
      state.queryForm.pageNum = val
      queryData()
    }

    onMounted(() => {
      const customInfo = store.getters['user/customInfo']
      if (customInfo.tenantKey !== 'WeMeet') {
        state.queryForm.eventKey = customInfo.tenantKey
      }
      queryData()
    })

    watch(
      () => proxy.$route.query.enterpriseName,
      (newVal, oldVal) => {
        console.log(newVal, oldVal, '===1222222')
        if (newVal) {
          state.queryForm.enterpriseName = newVal
          queryData()
        }
      }
    )

    const handlePayDetail = (row) => {
      let checkItem = state.payTypeOption.filter((v) => v.value == row.payType)
      // 微信支付且已支付
      if (row.status == 'PAY_OVER' && row.payType == 'WECHAT_PAY') {
        return checkItem[0].outOrderNo
      }
    }

    const handlePayStatus = (row) => {
      return row.status == 'PAY_WAIT'
        ? '待支付'
        : row.status == 'PAY_OVER'
          ? '支付成功'
          : row.status == 'PAY_CONFIRMED'
            ? '支付待确认'
            : row.status == 'PAY_NOT_PASS'
              ? '支付被驳回'
              : '支付取消'
    }

    const handleAuditStatus = (row) => {
      return row.status == 'PENDING_AUDIT'
        ? '待审核'
        : row.status == 'TRIAL'
          ? '试用'
          : row.status == 'AUDIT_APPROVED'
            ? '审核通过'
            : '审核驳回'
    }

    const handlePayType = (row) => {
      let checkItem = state.payTypeOption.filter((v) => v.value == row.orderMethod)
      if (checkItem.length > 0) {
        return checkItem[0].label
      } else {
        return '暂无数据'
      }
    }

    const handleDate = (date) => {
      return parseTime(date)
    }

    return {
      ...toRefs(state),
      handleEdit,
      queryData,
      fetchData,
      handleSizeChange,
      handleCurrentChange,
      handleDelete,
      Delete,
      Search,
      Plus,
      resetQueryData,
      handlePayType,
      handlePayDetail,
      handlePayStatus,
      handleAuditStatus,
      handleDate,
      customInfo: computed(() => store.getters['user/customInfo']),
    }
  },
})
</script>
<style lang="scss" scoped></style>
